import React, { useEffect, useState } from "react";
import { Grid, Card, Typography, CardHeader, CardContent, Stack, Box, Divider, Avatar } from "@mui/material";
import { useParams } from "react-router-dom";
import { Helmet } from "react-helmet-async";
import errorHandler from "../../utils/errorHandler";
import CardLayout from "../../layouts/CardLayout";
import { IMAGE_BASE } from "../../utils/constants";
import { bitPackageServices } from "../../services/AllServices";
import { capitalizeFirstLetter } from "../../utils/helpers";

const ViewBidPackage = () => {
  const { id } = useParams();
  const [data, setData] = useState({});

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await bitPackageServices.getById({ id });
        setData(response?.data?.data);
      } catch (error) {
        errorHandler(error);
      }
    };

    fetchData();
  }, [id]);

  return (
    <Box>
      <Helmet>
        <title>Bid Package</title>
      </Helmet>
      <CardLayout>
        <CardHeader title="Bid Package Details" />
        <CardContent>
          <Grid container spacing={3}>
            <Grid size={{ xs: 12 }}>
              <Card sx={{ boxShadow: 4, borderRadius: 3, overflow: "hidden" }}>
                <CardContent>
                  <Stack spacing={3}>

                    {/* Name */}
                    <Box>
                      <Typography variant="h6">Image</Typography>
                      <Typography variant="body1" sx={{ overflowWrap: "break-word" }}>
                        <Box
                          sx={{
                            width: 120,
                            height: 120,
                            mx: "auto",
                            cursor: "pointer",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            border: "2px dashed #ccc",
                            borderRadius: "50%",
                          }}>
                          <img
                            src={data?.image ? IMAGE_BASE + data?.image : "/"}
                            alt="Ticket"
                            style={{ width: "100%", maxWidth: 300, borderRadius: 8 }}
                          />
                        </Box>
                      </Typography>
                    </Box>
                    <Divider />


                    {/* Name */}
                    <Box>
                      <Typography variant="h6">Name</Typography>
                      <Typography variant="body1" sx={{ overflowWrap: "break-word" }}>
                        {capitalizeFirstLetter(data?.name) || "N/A"}
                      </Typography>
                    </Box>
                    <Divider />

                    {/* Price */}
                    <Box>
                      <Typography variant="h6">Price</Typography>
                      <Typography variant="body1" sx={{ overflowWrap: "break-word" }}>
                        {data?.price || "N/A"}
                      </Typography>
                    </Box>
                    <Divider />

                    {/* Earn Bids */}
                    <Box>
                      <Typography variant="h6">Earn Bids</Typography>
                      <Typography variant="body1" sx={{ overflowWrap: "break-word" }}>
                        {data?.earnBids || "N/A"}
                      </Typography>
                    </Box>
                    <Divider />

                    {/* Description */}
                    <Box>
                      <Typography variant="h6">Description</Typography>
                      {data?.description?.length > 0 ? (
                        <ul style={{ paddingLeft: '1rem' }}>
                          {data.description.map((item, index) => (
                            <li key={index}>
                              <Typography variant="body2" sx={{ overflowWrap: 'break-word' }}>
                                {item}
                              </Typography>
                            </li>
                          ))}
                        </ul>
                      ) : (
                        <Typography variant="body2">No description available</Typography>
                      )}
                    </Box>


                    <Divider />

                    {/* Status */}
                    <Box>
                      <Typography variant="h6">Status</Typography>
                      <Typography variant="body1" sx={{ overflowWrap: "break-word" }}>
                        {capitalizeFirstLetter(data?.status) || "N/A"}
                      </Typography>
                    </Box>
                    <Divider />

                    {/* Timestamps */}
                    <Box>
                      <Typography variant="h6">Created At</Typography>
                      <Typography variant="body2">
                        {new Date(data?.createdAt).toLocaleString() || "N/A"}
                      </Typography>
                    </Box>
                    <Divider />

                    <Box>
                      <Typography variant="h6">Updated At</Typography>
                      <Typography variant="body2">
                        {new Date(data?.updatedAt).toLocaleString() || "N/A"}
                      </Typography>
                    </Box>
                  </Stack>
                </CardContent>
              </Card>
            </Grid>
          </Grid>
        </CardContent>
      </CardLayout>
    </Box>
  );
};

export default ViewBidPackage;
